import * as React from 'react';
import { StandardLocalWidget, any, async, fromJSX } from "widgets-for-react";
import { DataLayer, PIIData } from 'utils/datalayer';
import { SubscriptionPriceSelectorState, subscriptionPriceSelectorStateUpdaters } from "./subscriptionPriceSelectorState";
import { SubscriptionPriceOption } from './subscriptionPriceSelectorLayout';
import { RootLayout } from 'site/rootLayout';

export const subscriptionPriceSelectorWidget = (
  pageKind: 'account-details' | 'trial-to-pro', piiData?: PIIData): StandardLocalWidget<SubscriptionPriceSelectorState> => currentState =>
  any([
    async(currentState.availableSubscriptionPrices).map(subscriptionPriceSelectorStateUpdaters.availableSubscriptionPrices),
    currentState.validator.widget().map(subscriptionPriceSelectorStateUpdaters.validation),
    fromJSX(setState =>
      {
        if(currentState.availableSubscriptionPrices.kind === 'loaded') {
          return <SubscriptionPriceOption
            kind={pageKind}
            availableSubscriptions={currentState.availableSubscriptionPrices.value}
            currentSubscription={currentState.input}
            select={s => {
              setState(subscriptionPriceSelectorStateUpdaters.input(_ => s));
              DataLayer.upgradeFlowStep1(false, piiData, s.PaymentFrequency);
            }} />;
        }

        return <RootLayout.Loader hasWrapper={true} showText={true} />
      }
    )
  ])